import { render, staticRenderFns } from "./Realworks.vue?vue&type=template&id=3085496c&"
import script from "./Realworks.vue?vue&type=script&lang=ts&"
export * from "./Realworks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports